import { render, staticRenderFns } from "./TwoRow.vue?vue&type=template&id=67c1df6a&scoped=true"
import script from "./TwoRow.vue?vue&type=script&lang=js"
export * from "./TwoRow.vue?vue&type=script&lang=js"
import style0 from "./TwoRow.vue?vue&type=style&index=0&id=67c1df6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c1df6a",
  null
  
)

export default component.exports